import { apiRequest } from '../apiRequest';
import { LOGIN_ENDPOINT } from '../urls';

export const login = data => {
  return apiRequest('POST', LOGIN_ENDPOINT, data);
};
